import React, {
  FunctionComponent,
  ReactNode,
} from 'react';
import classnames from 'classnames';

import { capitalize } from '@helpers/humanize';

interface CheckboxGroupProps {
  name: string;
  styleClassNames: { [key: string]: string };
  variantName: string;
  className?: string;
  containerId?: string;
  'aria-labelledby'?: string;
}

const baseName = 'checkbox-group';

const BaseCheckboxGroup: FunctionComponent<CheckboxGroupProps> = (
  props,
) => {
  const {
    'aria-labelledby': ariaLabelledBy,
    children,
    className,
    containerId,
    name,
    styleClassNames,
    variantName,
  } = props;

  return (
    <div
      aria-label={!ariaLabelledBy ? capitalize(name) : undefined}
      aria-labelledby={ariaLabelledBy || undefined}
      className={classnames(
        className,
        `bf-${baseName}__${variantName}`, // base-variant class for post consumption styling
        styleClassNames[variantName], // class for css modules
      )}
      id={containerId}
      role="group"
    >
      {children}
    </div>
  );
};

export default BaseCheckboxGroup;
